export default {
    user: {
        error_server_connection: "Ops! Não foi possível atualizar o controle de acesso. Tente novamente mais tarde.",
    },
    userForm: {
        unexpected_error: "Ops! Não foi possível cadastrar o usuário. Tente novamente mais tarde.",
        error_server_connection: "Ops! Não foi possível cadastrar o usuário. Tente novamente mais tarde.",
    },
    userFormEdit: {
        unexpected_error: "Ops! Não foi possível editar o usuário. Tente novamente mais tarde.",
        error_server_connection: "Ops! Não foi possível editar o usuário. Tente novamente mais tarde.",
    },
    userFilter: {
        unexpected_error: "Ops! Não foi possível realizar a consulta. Tente novamente mais tarde.",
        error_server_connection: "Ops! Não foi possível realizar a consulta. Tente novamente mais tarde.",
    },
    userDelete: {
        error_server_connection: "Ops! Não foi possível excluir o usuário. Tente novamente mais tarde.",
    }
}